import React, { FC, useMemo } from 'react';
import { GetLettersResponse } from 'src/api/requests/getLetters';
import { GTAGPrefix } from 'src/hooks/useGTAG';
import { ItemListName } from 'src/api/analytic.types';
import { getAnalyticPreparedDrugList } from 'src/hooks/useAnalytics/useAnalytics.helpers';
import Constraints from 'src/shared-components/Constraints/Constraints';
import { FormattedMessage } from 'react-intl';
import useTopDrugsStore from 'src/hooks/useTopDrugsStore';

import Steps from './components/Steps/Steps';
import Page from '../../shared-components/Page/Page';
import AboutUsContainer from './components/AboutUs/AboutUsContainer';
import DrugsCarouselContainer from '../../shared-components/TopDrugs/DrugsCarouselContainer';
import CategoryPlatesContainer from './components/CategoryPlates/CategoryPlatesContainer';
import PartnersContainer from './components/Partners/PartnersContainer';
import CommentsContainers from './components/CommentsContainers/CommentsContainers';
import ViewedDrugsContainer from '../../shared-components/ViewedDrugs/ViewedDrugsContainer';
import SeoTextContainer from './components/SeoTextContainers/SeoTextContainers';
import trns from './components/SeoTextContainers/trns';
import NavigationLink from '../../shared-components/NavigationLink/NavigationLink';

interface Props {
  lettersListResponse: GetLettersResponse[];
}
const HomeContainer: FC<Props> = ({ lettersListResponse }) => {
  const { topDrugsList } = useTopDrugsStore();

  const drugListWithAnalyticData = useMemo(
    () =>
      getAnalyticPreparedDrugList({
        drugs: topDrugsList,
        itemListName: ItemListName.TopSearch
      }),
    [topDrugsList?.length]
  );

  return (
    <Page>
      <CategoryPlatesContainer lettersList={lettersListResponse} />
      <div className="flex pt-10">
        <DrugsCarouselContainer
          drugsList={drugListWithAnalyticData}
          gtagPrefix={GTAGPrefix.top}
        />
      </div>
      <div className="flex py-10">
        <ViewedDrugsContainer itemListName={ItemListName.YouBrowsedMain} />
      </div>
      <Steps />
      <AboutUsContainer />
      <CommentsContainers />
      <PartnersContainer />
      <SeoTextContainer />
      <div className={'px-4 lm:flex lm:pb-10'}>
        <Constraints className="w-full pb-10 m:pb-6">
          <h1 className="uppercase text-astronautBlue fs-header3-bold">
            <FormattedMessage {...trns.alphabeticalIndex} />
          </h1>
          <div className="h-px bg-bahamaBlue mt-4 mb-4 mr-4" />
          <div>
            {lettersListResponse?.map((letter, index) => {
              return (
                <NavigationLink
                  key={index}
                  href={{ pathname: `/letter/${letter.translitName}` }}
                >
                  <span className="cursor-pointer fs-body-lg-bold text-astronautBlue mr-[10px] m:mr-[3px] leading-[43px]">
                    {letter.name}{' '}
                  </span>
                </NavigationLink>
              );
            })}
          </div>
        </Constraints>
      </div>
    </Page>
  );
};

export default HomeContainer;
